import React, { useState } from 'react';
import { Sparkles, AlertCircle, CheckCircle2, Lightbulb } from 'lucide-react';

const TABS = ['All', 'Content', 'Structure'];

export function SmartSuggestions({ suggestions }) {
  const [tab, setTab] = useState('All');
  const filtered = tab === 'All' ? suggestions : suggestions.filter((s) => s.category === tab.toLowerCase());
  const allGood = suggestions.every((s) => s.tone === 'success');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <div style={{ padding: '1.1rem 1.1rem 0.75rem', borderBottom: '1px solid #F1F5F9' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: '0.75rem' }}>
          <Sparkles size={16} color="#0D9488" />
          <span style={{ fontFamily: 'Cabinet Grotesk, sans-serif', fontSize: '0.9375rem', fontWeight: 700, color: '#002A38' }}>Smart Suggestions</span>
          <span style={{ fontSize: '0.5625rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#0D9488', background: '#CCFBF1', padding: '2px 6px', borderRadius: 999 }}>AI</span>
        </div>
        <div style={{ display: 'flex', gap: 4, background: '#F1F5F9', padding: 3, borderRadius: 10 }}>
          {TABS.map((t) => {
            const count = t === 'All' ? suggestions.length : suggestions.filter((s) => s.category === t.toLowerCase()).length;
            return (
              <button
                key={t}
                type="button"
                data-testid={`suggestion-tab-${t.toLowerCase()}`}
                onClick={() => setTab(t)}
                style={{
                  flex: 1, padding: '0.35rem', borderRadius: 8, border: 'none', cursor: 'pointer',
                  fontSize: '0.75rem', fontWeight: 600,
                  background: tab === t ? '#fff' : 'transparent',
                  color: tab === t ? '#0076A3' : '#64748B',
                  boxShadow: tab === t ? '0 1px 2px rgba(15,23,42,0.08)' : 'none',
                  transition: 'background-color 0.15s, color 0.15s',
                }}
              >
                {t} ({count})
              </button>
            );
          })}
        </div>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '0.9rem 1.1rem', display: 'flex', flexDirection: 'column', gap: '0.6rem' }} data-testid="suggestions-list">
        {allGood && tab === 'All' && (
          <div style={{ textAlign: 'center', padding: '1.5rem 0.5rem', color: '#0D9488' }}>
            <CheckCircle2 size={28} style={{ margin: '0 auto 0.5rem' }} />
            <div style={{ fontSize: '0.875rem', fontWeight: 700 }}>Looking good!</div>
            <div style={{ fontSize: '0.75rem', color: '#64748B', marginTop: 4 }}>Your job description is well-structured.</div>
          </div>
        )}
        {filtered.map((s) => {
          const warn = s.tone === 'warning';
          const Icon = s.tone === 'success' ? CheckCircle2 : warn ? AlertCircle : Lightbulb;
          const c = s.tone === 'success' ? '#0D9488' : warn ? '#F59E0B' : '#0284C7';
          const bg = s.tone === 'success' ? '#F0FDFA' : warn ? '#FFFBEB' : '#F0F9FF';
          const bd = s.tone === 'success' ? '#99F6E4' : warn ? '#FDE68A' : '#BAE6FD';
          return (
            <div key={s.id} data-testid="suggestion-card" style={{ display: 'flex', gap: 10, padding: '0.7rem 0.8rem', borderRadius: 12, background: bg, border: `1px solid ${bd}` }}>
              <Icon size={16} color={c} style={{ flexShrink: 0, marginTop: 1 }} />
              <div>
                <div style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#002A38', lineHeight: 1.35 }}>{s.text}</div>
                {s.detail && <div style={{ fontSize: '0.6875rem', color: '#64748B', marginTop: 3, lineHeight: 1.4 }}>{s.detail}</div>}
              </div>
            </div>
          );
        })}
        {!allGood && filtered.length === 0 && (
          <div style={{ textAlign: 'center', padding: '1.5rem 0.5rem', color: '#94A3B8', fontSize: '0.8125rem' }}>No {tab.toLowerCase()} suggestions right now.</div>
        )}
      </div>
    </div>
  );
}
